import type { FindHyperguestHotelsInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

export const useHyperguestHotels = (input: FindHyperguestHotelsInput) =>
  trpc.hyperguestHotels.find.useQuery(input, {
    placeholderData: keepPreviousData,
  });
